import store from '@/store'

export default {
    install(Vue) {
        Vue.prototype.cf = this
        this.$storage = Vue.prototype.$storage
    },

    isJSON(str) {
        if (typeof str === "string") {
            try {
                if (str.indexOf("{") > -1) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        } else if (typeof str === "object") {
            return true;
        }
        return false;
    },
     getObjectValues(object,field)
    {
        var values = [];
        for (var property in object)
            values.push(object[property][field]);
        return values;
    },
    setLastRouter(to) {
        let {name, query, params} = to;
        let lastrouter = {name, query, params}
        this.$storage.set("lastroute", lastrouter);
    },
    getLastRouter() {
        return this.$storage.get("lastroute").then((res) => {
            let lastroute = res
            if (!res) {
                lastroute = {name: "exchange"}
            }
            return lastroute
        });

    },

    isWeChat() {
        return (/micromessenger/i.test(window.navigator.userAgent))
    },

    getToken() {
        let userInfo = store.getters.getUserInfo
        if (userInfo && userInfo.token) return userInfo.token;
        return false;
    },
    getUserInfo() {
        let userInfo = store.getters.getUserInfo
        if (userInfo) return userInfo;
        return false;
    },
    countTime(createTime, fmt){
        var timestamp = new Date().getTime()/1000;
        var d, h, m, s,leftTime = timestamp-createTime;
        if (leftTime >= 0) {
            d = Math.floor(leftTime / 60 / 60 / 24);
            h = Math.floor(leftTime / 60 / 60 % 24);
            m = Math.floor(leftTime / 60 % 60);
            s = Math.floor(leftTime  % 60);
        }
        if (d) {
            return d + "天";
        } else if(h) {
            // return d + "天" + h + "小时" + m + "分" + s + "秒";
            return h + "小时";

        } else if(m) {
            return m + "分";
        }else {
            return s + "秒";
        }

    },
    countTimes(createTime, fmt){
        let arr = createTime.split(",")
        let datetime = arr[0]
        var timestamp = new Date().getTime()/1000;
        // console.log(arr,timestamp)
        var d, h, m, s,leftTime = timestamp-datetime*1;
        if (leftTime >= 0) {
            d = Math.floor(leftTime / 60 / 60 / 24);
            h = Math.floor(leftTime / 60 / 60 % 24);
            m = Math.floor(leftTime / 60 % 60);
            s = Math.floor(leftTime  % 60);
        }
        if (d) {
            return d + "天";
        } else if(h) {
            // return d + "天" + h + "小时" + m + "分" + s + "秒";
            return h + "小时";

        } else if(m) {
            return m + "分";
        }else {
            return s + "秒";
        }

    },
    formatDate2(date){
        var year = date.getFullYear();
        var month = (date.getMonth()+1);
        var day = date.getDate();
        var week = ['Su .','Mo .','Tu .','We .','Th .','Fr .','Sa .'][date.getDay()];
        var weeknum = ['0','1','2','3','4','5','6'][date.getDay()];

        return {day,week,weeknum};
    },
    addDate(date,n){
        date.setDate(date.getDate()+n);
        return date;
    },
    setDate(date){
        var week = date.getDay()-1;
        date = this.addDate(date,week*-1);
        var cells = []
        for(var i = 0;i<7;i++){
          cells.push(this.formatDate(i==0 ? date : this.addDate(date,1)));
        }
        return cells;
    },
    curentTime(date){
        var now = new Date();

        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分

        // var clock = year + "-";
        var clock = '';

        if(month < 10)
            clock += "0";

        clock += month + "月";

        if(day < 10)
            clock += "0";

        clock += day + "日";

        // if(hh < 10)
        //     clock += "0";

        // clock += hh + ":";
        // if (mm < 10) clock += '0';
        // clock += mm;
        return(clock);
    },
    formatTime(date) {
        var tem = new Date(date)
        var year = tem.getFullYear();
        var month = tem.getMonth() + 1;
        var day = tem.getDate();
        var hh = tem.getHours();
        var mm = tem.getMinutes();
        var clock = '';
        // if(hh < 12) hh += "am";
        // else hh += "pm";
        //     clock += "0";
        if(hh < 10)
            clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        // return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
        return [year, month, day].map(this.formatNumber).join("/")+ ' ' +clock;
    },
    formatTimes(date) {
        var tem = new Date(date)
        var year = tem.getFullYear();
        var month = tem.getMonth() + 1;
        var day = tem.getDate();
        var hh = tem.getHours();
        var mm = tem.getMinutes();
        var clock = '';
        // if(hh < 12) hh += "am";
        // else hh += "pm";
        //     clock += "0";
        if(hh < 10)
            clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        // return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
        return month+'月'+day+'日';
    },
    formatDate(date,type=1) {
        var tem = new Date(date)
        var year = tem.getFullYear();
        var month = tem.getMonth() + 1;
        var day = tem.getDate();
        var hh = tem.getHours();
        var mm = tem.getMinutes();
        var clock = '';
        if(type==1){
            return year+'-'+month;
        }else if(type==2){
            return day;
        }
    },
    formatNumber(n){
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    goBack(e){
        e.$router.back(-1)
    }

}
